import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user']),
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover o pet <b>${this.currentEntity.name}</b>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/pets/resources/computed.js